import Accordion from "react-bootstrap/Accordion";
import { Col, Row } from "react-bootstrap";

function VendorAccordionComponent() {
  return (
    <Row>
      <Col lg={6} xl={4} md={6}>
        <Accordion defaultActiveKey="0">
          <Accordion.Item eventKey="0">
            <Accordion.Header>Project & Task Management</Accordion.Header>
            <Accordion.Body>
              <ul>
                <li>Task Assignment</li>
                <li>Project Timelines</li>
                <li>Time Tracking</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1">
            <Accordion.Header>Team Management</Accordion.Header>
            <Accordion.Body>
              <ul>
                <li>Task Assignment</li>
                <li>Project Timelines</li>
                <li>Time Tracking</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            <Accordion.Header>Views</Accordion.Header>
            <Accordion.Body>
              <ul>
                <li>Task Assignment</li>
                <li>Project Timelines</li>
                <li>Time Tracking</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Col>
      <Col lg={6} xl={4} md={6}>
        <Accordion defaultActiveKey="0">
          <Accordion.Item eventKey="1">
            <Accordion.Header>Automation</Accordion.Header>
            <Accordion.Body>
              <ul>
                <li>Workflow Automation</li>
                <li>Prebuilt Automation Recipes</li>
                <li>Custom Automation</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="5">
            <Accordion.Header>Templates</Accordion.Header>
            <Accordion.Body>
              <ul>
                <li>Workflow Automation</li>
                <li>Prebuilt Automation Recipes</li>
                <li>Custom Automation</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="6">
            <Accordion.Header>Reporting and Analytics</Accordion.Header>
            <Accordion.Body>
              <ul>
                <li>Workflow Automation</li>
                <li>Prebuilt Automation Recipes</li>
                <li>Custom Automation</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Col>
      <Col lg={6} xl={4} md={6}>
        <Accordion defaultActiveKey="0">
          <Accordion.Item eventKey="7">
            <Accordion.Header>Collaboration Tools</Accordion.Header>
            <Accordion.Body>
              <ul>
                <li>Comments and Mentions</li>
                <li>File Sharing</li>
                <li>Updates Section</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="8">
            <Accordion.Header>Collaboration Tools</Accordion.Header>
            <Accordion.Body>
              <ul>
                <li>Comments and Mentions</li>
                <li>File Sharing</li>
                <li>Updates Section</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Col>
    </Row>
  );
}

export default VendorAccordionComponent;
